import { useEffect } from 'react';
import { useTheme } from 'next-themes';

export const useRemoveDarkClass = () => {
  const { theme } = useTheme();

  useEffect(() => {
    if (theme === 'light') {
      document.documentElement.classList.remove('dark');
    }
  }, [theme]);
};
